




















































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { getTopicPart } from '@/api/exam/topicGroup'
import { queryTopicBankList } from '@/api/exam/topicBank'
import { YKDRightDrawer } from 'gum-ui'
import { State, Action, Getter, namespace } from 'vuex-class'
import TopicBank from '@/model/exam/topicBank'
import { searchByCustomType } from '@/api/exam/topicBank'

import RandomCreateTopic1CenterDialog from '@/apps/exam/views/topicgroup/components/RandomCreateTopic1CenterDialog.vue'

const TopicBank = namespace('app-exam/topicBank')
import TopicGroup, { TopicPart } from '@/model/exam/topicGroup'
import TopicGroupSelectedRecord from '@/model/exam/topicGroupSelectedRecord'
const TopicPart = namespace('app-exam/topicPart')
import { message } from 'ant-design-vue'

@Component({
  components: { YKDRightDrawer, RandomCreateTopic1CenterDialog }
})
export default class RandomCreateTopic1 extends Vue {
  @TopicBank.State('selectTopicBanks') selectTopicBanks!: TopicBank[]
  @TopicBank.Action('saveSelectTopicBanks') saveSelectTopicBanks!: Function
  @TopicBank.Action('deleteSelectTopicBanks') deleteSelectTopicBanks!: Function
  @TopicPart.Action('editTopicPart') editTopicPart!: Function
  @Prop() private randomCreateTopicVisible?: boolean
  @Prop() private title?: string
  @Prop() private topicPart: TopicPart = {}
  private choseSelectTopicNumber: number = 0
  private topicBanks: TopicBank[] = []
  private errorText: string = ''
  private isError: boolean = false
  private isTopic: string = 'false'
  private isShowSelectData: boolean = false
  private isErrorTop: boolean = false
  private isErrorTopText: string = ''
  private loading: boolean = false
  private centerDrawer: boolean = false
  addTopic() {
    this.centerDrawer = true
  }
  async closeCenter(number: any) {
    if (number) {
      this.choseSelectTopicNumber = number
    }
    this.centerDrawer = false
    await this.initData()
  }
  //
  close() {
    this.$emit('closeRandomCreateTopic')
  }
  async confirm() {
    if (this.isError) {
      this.errorText = '选择数量不能大于出题总数!'
      return
    }
    //添加选择的题库
    let selectedRecords: TopicGroupSelectedRecord[] = []
    if (this.selectTopicBanks && this.selectTopicBanks.length > 0) {
      this.selectTopicBanks.forEach((item, index) => {
        let selectedRecord: TopicGroupSelectedRecord = {}
        selectedRecord.topicNumber = item.selectRecordNumber
        selectedRecord.topicBankId = item.id
        selectedRecord.topicGroupId = this.topicPart.topicGroupId
        selectedRecords.push(selectedRecord)
      })
    }

    this.topicPart.records = selectedRecords
    await this.editTopicPart(this.topicPart)
    this.$emit('closeRandomCreateTopic')
  }
  deleteselectRecordNumber(item: any) {
    this.choseSelectTopicNumber = 0
    this.selectTopicBanks.forEach((tb, tbIndex) => {
      if (tb.selectRecordNumber) {
        this.choseSelectTopicNumber += Number(tb.selectRecordNumber!)
      }
    })
    if (
      item.selectRecordNumber <
      Number(this.topicPart.topicNumber!) - this.choseSelectTopicNumber
    ) {
      this.isError = false
    }
  }
  //根据题目类型筛选
  async handleSearch(e: any) {
    if (e) {
      this.topicBanks = await searchByCustomType(e)
    } else {
      await this.initTopicBank()
    }
    let newTopicBankDatas: TopicBank[] = []

    if (this.topicBanks && this.topicBanks.length > 0) {
      this.topicBanks.forEach((item, index) => {
        item.num = index + 1
        if (this.selectTopicBanks && this.selectTopicBanks.length > 0) {
          this.selectTopicBanks.forEach(select => {
            if (select.name === item.name) {
              item.selectRecordNumber = select.selectRecordNumber
            }
          })
        }
        newTopicBankDatas.push(item)
      })
    }
    this.topicBanks = newTopicBankDatas
  }
  OnInput(item: any) {
    if (item.selectRecordNumber) {
      if (item.selectRecordNumber.length > 1) {
        let num = ''
        for (let i = 0; i < item.selectRecordNumber.length - 1; i++) {
          num = num + item.selectRecordNumber[i]
        }
        this.choseSelectTopicNumber = this.choseSelectTopicNumber - Number(num)
      }
      if (
        item.selectRecordNumber >
        Number(this.topicPart.topicNumber!) - this.choseSelectTopicNumber
      ) {
        if (
          Number(this.topicPart.topicNumber!) != this.choseSelectTopicNumber
        ) {
          this.isError = true
          this.errorText = '选择数量不能大于出题总数!'
        }
      } else if (item.topicNumber < item.selectRecordNumber) {
        this.isError = true
        this.errorText = '选择数量不能大于题库总数!'
      } else {
        this.isError = false
        this.choseSelectTopicNumber += Number(item.selectRecordNumber)
      }
    } else {
      if (
        this.topicPart &&
        this.topicPart.records &&
        this.topicPart.records.length > 0
      ) {
        this.topicPart.records.forEach((item, index) => {
          let topicBank: TopicBank = {}

          this.topicBanks.forEach((tb, tbIndex) => {
            if (item.topicBankId === tb.id) {
            }
          })
        })
      } else if (this.selectTopicBanks && this.selectTopicBanks.length > 0) {
        this.choseSelectTopicNumber = 0
        this.selectTopicBanks.forEach((item, index) => {
          this.choseSelectTopicNumber += Number(item.selectRecordNumber!)
        })
      } else {
        this.choseSelectTopicNumber = 0
      }
    }
    this.saveSelectTopicBanks(this.selectTopicBanks)
  }
  @Watch('randomCreateTopicVisible')
  async initData() {
    let newTopicBanks: TopicBank[] = []
    //初始化以选题目数量
    this.choseSelectTopicNumber = 0
    this.isError = false
    this.isErrorTop = false
    await this.saveSelectTopicBanks([])
    this.topicPart = await getTopicPart(this.topicPart.id!)
    if (
      this.topicPart &&
      this.topicPart.records &&
      this.topicPart.records.length > 0
    ) {
      //组装数据
      this.isTopic = 'false'
      this.isShowSelectData = true
      this.topicPart.records.forEach((item, index) => {
        let topicBank: TopicBank = {}

        this.topicBanks.forEach((tb, tbIndex) => {
          if (item.topicBankId === tb.id) {
            topicBank.name = tb.name
            topicBank.selectRecordNumber = item.topicNumber
            topicBank.topicCategory = tb.topicCategory
            topicBank.id = tb.id
            this.choseSelectTopicNumber += Number(item.topicNumber!)
          }
        })
        newTopicBanks.push(topicBank)
      })
    } else {
      this.isShowSelectData = false
      this.isTopic = 'true'
    }
    await this.saveSelectTopicBanks(newTopicBanks)
    let newTopicBankDatas: TopicBank[] = []

    if (this.topicBanks && this.topicBanks.length > 0) {
      this.topicBanks.forEach((item, index) => {
        if (this.selectTopicBanks && this.selectTopicBanks.length > 0) {
          this.selectTopicBanks.forEach(select => {
            if (select.name === item.name) {
              item.selectRecordNumber = select.selectRecordNumber
            }
          })
        }
        newTopicBankDatas.push(item)
      })
    }
    this.topicBanks = newTopicBankDatas
  }

  async initTopicBank() {
    this.topicBanks = await queryTopicBankList('', [], false)
    let newTopicBanks: TopicBank[] = []

    if (this.topicBanks && this.topicBanks.length > 0) {
      this.topicBanks.forEach((item, index) => {
        item.num = index + 1
        newTopicBanks.push(item)
      })
    }
  }
  async mounted() {
    await this.initTopicBank()
  }
  //选择题库
  async selectTopicBank(item: TopicBank) {
    //判断该题库有没有题目
    if (Number(item.topicNumber!) <= 0) {
      this.isErrorTop = true
      this.isErrorTopText = '该题库没有题目'
      return
    } else if (this.choseSelectTopicNumber === this.topicPart.topicNumber) {
      this.isErrorTop = true
      this.isErrorTopText = '选择数量已满'
      return
    } else {
      this.isErrorTop = false
    }

    let topicBanks: TopicBank[] = []
    topicBanks.push(item)
    this.isShowSelectData = true
    this.isTopic = 'false'
    //判断是否重修复选择
    let is: boolean = true
    let isRepeat = true
    this.selectTopicBanks.forEach((item, index) => {
      topicBanks.forEach((se, seIndex) => {
        if (item.id === se.id) {
          is = false
        }
      })
      if (!is) {
        message.info('重复选择', 2)
        isRepeat = false
        return
      }
    })

    if (isRepeat) {
      item.selectRecordNumber = undefined
      await this.saveSelectTopicBanks(topicBanks)
    }
  }
  async deletSelectTopicBank(topicBank: TopicBank) {
    if (topicBank.selectRecordNumber) {
      this.choseSelectTopicNumber =
        this.choseSelectTopicNumber - Number(topicBank.selectRecordNumber!)
    }
    topicBank.selectRecordNumber = 0
    await this.deleteSelectTopicBanks(topicBank)
    let selectedRecords: TopicGroupSelectedRecord[] = []
    if (this.selectTopicBanks && this.selectTopicBanks.length > 0) {
      this.selectTopicBanks.forEach((item, index) => {
        let selectedRecord: TopicGroupSelectedRecord = {}
        selectedRecord.topicNumber = item.selectTopicNumber
        selectedRecord.topicBankId = item.id
        selectedRecord.topicGroupId = this.topicPart.topicGroupId
        selectedRecords.push(selectedRecord)
      })
    }

    this.topicPart.records = selectedRecords
    // await this.editTopicPart(this.topicPart)
  }
}
